import {needAuth} from "../instance/Instance";
import {apiRequest} from "../../components/Utils/SimmsUtils";

/**
 * POST /v2/approve/set
 * @param {{
 *   users: Array<{ id: number }>,
 *   approvalProcessId?: number,
 *   name?: string,
 *   description?: string,
 * }} requestDto
 */
export async function setApproves(requestDto) {
    try {
        return await needAuth.post("/v2/approve/set", requestDto);
    } catch (error) {
        return error;
    }
}

export async function setApprovesWithHandler(requestDto, success, failure) {
    return apiRequest(() => needAuth.post("/v2/approve/set", requestDto), success, failure);
}

/**
 * GET /v2/preset
 * @returns {Promise<import("axios").AxiosResponse<Array<{
 *   id: number,
 *   ownerId: number,
 *   approvalProcessId: number,
 *   name: string,
 *   description?: string,
 *   createdAt?: string,
 *   updatedAt?: string,
 * }>>>}
 */
export async function getApprovalPresets() {
    try {
        return await needAuth.get("/v2/preset");
    } catch (error) {
        return error;
    }
}

/**
 * GET /v2/preset/{presetId}
 * @returns {Promise<import("axios").AxiosResponse<{
 *   id: number,
 *   name: string,
 *   description?: string,
 *   orders?: number,
 *   approvalGroups?: Array,
 *   approvers?: Array<{ id: number, name: string, department?: object, profileImage?: string }>,
 * }>>}
 */
export async function getApprovalPresetById(presetId) {
    try {
        return await needAuth.get(`/v2/preset/${presetId}`);
    } catch (error) {
        return error;
    }
}

/**
 * POST /v2/preset
 * @param {{ name: string, description?: string, users: Array<{ id: number }> }} requestDto
 */
export async function saveApprovalPreset(requestDto) {
    try {
        return await needAuth.post("/v2/preset", requestDto);
    } catch (error) {
        return error;
    }
}
